import { render, staticRenderFns } from "./vExhibitorResetPassOrBindCode.vue?vue&type=template&id=6c2882b8&scoped=true&"
import script from "./vExhibitorResetPassOrBindCode.vue?vue&type=script&lang=js&"
export * from "./vExhibitorResetPassOrBindCode.vue?vue&type=script&lang=js&"
import style0 from "./vExhibitorResetPassOrBindCode.vue?vue&type=style&index=0&id=6c2882b8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2882b8",
  null
  
)

export default component.exports